<template>
<div class='updateRemark'>
    <mt-popup v-model="bupdateRemark" class='guestInfo' popup-transition="popup-fade">
        <h2>{{$t('updateRemark_title')}}</h2>
        <div class="guestSwiper">
            <textarea class="remark" v-model="req.remark" :placeholder="$t('placeHolder_Empty')"></textarea>
        </div>
        <div class="btn">
            <div class="unSure" @click="bupdateRemark=false">{{$t('cancel')}}</div>
            <div class="sure" @click="save">{{$t('determine')}}</div>
        </div>
    </mt-popup>
</div>
</template>
<script>
export default {
    data() {
        return {
            bupdateRemark: false,
            req: {
                id: null,
                remark: null,
            }
        };
    },
    props: {

    },
    mounted() {},
    methods: {
        show(id, remark) {
            this.bupdateRemark = true;
            this.req.id = id;
            this.req.remark = remark;
        },
        save() {
            if(!this.req.remark){
                this.msg2(this.$t('updateRemark_notEmpty'));
                return;
            }
            this.confirm2(this.$t('updateRemark_confirm'),action => {
                    this.$http
                        .post("/mobilepmsapi/reception/updateMasterRemark", this.req)
                        .then(res => {
                            if (res.data.result == 0) {
                                this.bupdateRemark = false;
                                this.$emit("success");
                            } else {
                                this.msg2(res.data.msg);
                            }
                        });
                })
        },
    },
    components: {

    }
};
</script>

<style lang="less">
.updateRemark {
    .guestInfo {
        width: 90%;
        height: 330px;
        position: absolute;
        margin: 0 auto;
        background-color: #fff;
        border-radius: 10px;
        h2 {
            font-size: 18px;
            color: #666666;
            text-align: center;
            font-style: normal;
            padding: 10px 0;
        }
        .mint-cell-title {
            width: 80px;
        }
        .guestSwiper {
            padding: 0 4%;
            p {
                font-size: 18px;
                color: #57b658;
                padding: 20px 0 20px 5px;
            }
        }
        .btn {
            height: 55px;
            border-top: 1px solid #bdbdbd;
            text-align: center;
            font-size: 16px;
            position: absolute;
            bottom: 0;
            width: 100%;
            .unSure {
                border-right: 1px solid #bdbdbd;
                width: 50%;
                box-sizing: border-box;
                float: left;
                line-height: 55px;
            }
            .sure {
                width: 50%;
                box-sizing: border-box;
                float: left;
                line-height: 55px;
                color: #5190c3;
            }
        }
    }
    .remark {
        width: 100%;
        height: 5rem;
        padding: 15px;
        box-sizing: border-box;
    }
}
</style>



// WEBPACK FOOTER //
// updateRemark.vue?7f89309e